// extracted by mini-css-extract-plugin
module.exports = {"root":"Impressum_root__3-vfR","lastUpdated":"Impressum_lastUpdated__1HFxb"};